import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { KeyEventUtil } from 'utils'

const FechaEmisionFormGroup = ({ iError, iTouched, fIsSubmitting, vId }) => {
  React.useEffect(() => {
    if (!vId) {
      KeyEventUtil.leaveOnKeyEvent('inputDate-fechaEmision')
    }
  }, [vId])

  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-glosa', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='FEC EMISION' htmlFor='inputDate-fechaEmision' md={6} alignRightAt='md' />
      <Col md={6}>
        <Field name='fechaEmision'>
          {({ field }) => (
            <Form.InputDate
              {...field}
              id='inputDate-fechaEmision'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaEmisionFormGroup)
